// File: frontend/src/i18n/blog.js
// Version: 1.0 (2026-10-24, Part A)
// Description: словарь экрана «Блог» (EN/RU) и функция перевода для OS ELN.

const EN = {
    'blog.header.title': 'Blog Pipeline',
    'blog.header.subtitle': 'Articles published, queue status, and topic suggestions for estatelawnewyork.com',
    'blog.status.pipeline_date': 'Pipeline data as of {date}',
    'blog.banner.stale': 'Pipeline data is stale since {time}',
    'blog.banner.no_data': 'The pipeline has not sent any data yet',

    'blog.tabs.published': 'Published',
    'blog.tabs.pending': 'In Queue',
    'blog.tabs.suggestions': 'Topic Suggestions',

    'blog.published.filter_7d': '7 days',
    'blog.published.filter_30d': '30 days',
    'blog.published.filter_all': 'All days',
    'blog.published.count_7d': 'in last 7 days: {n}',
    'blog.published.count_total': 'total articles: {n}',
    'blog.published.col_date': 'Date',
    'blog.published.col_title': 'Title',
    'blog.published.col_category': 'Category',
    'blog.published.col_links': 'Link',
    'blog.published.col_status': 'Status',
    'blog.published.col_quality': 'Quality',
    'blog.published.col_verify': 'Quality',
    'blog.published.empty': 'No published articles found for the selected period',

    'blog.quality.not_measured': 'not measured',
    'blog.quality.partial': '{passed}/{total}, {not_measured} not measured',
    'blog.quality.checks_passed': 'checks passed ({n}/{total})',
    'blog.quality.checks_failed': '{n} failed',
    'blog.quality.failed_list': 'Failed: {list}',
    'blog.quality.check.answer_first': 'Direct answer in opening paragraph',
    'blog.quality.check.question_headings': 'Question-based headings',
    'blog.quality.check.faq_schema': 'FAQ schema (3-8 questions, 30-120 words)',
    'blog.quality.check.article_schema': 'Article schema (headline, dates, author, publisher)',
    'blog.quality.check.reviewed_by': 'Reviewed by Alan Vaitzman, Esq.',
    'blog.quality.check.statute_cited': 'Official statute citation (§) and links',
    'blog.quality.check.fact_check_verbatim': 'Quotes verified verbatim in browser',
    'blog.quality.check.internal_links': 'Internal blog and practice area links',
    'blog.quality.check.meta': 'Meta title, description, and canonical URL',
    'blog.quality.check.indexable': 'HTTP 200, in sitemap, no noindex',
    'blog.quality.check.canon_words': 'Adherence to ELN firm canon (no forbidden claims)',

    'blog.verify.ok': 'checks passed',
    'blog.verify.fail': 'check failed',
    'blog.verify.unverified': 'not measured',

    'blog.card.title': 'Article Details',
    'blog.card.btn_details': 'Details',
    'blog.card.slug': 'Slug',
    'blog.card.category': 'Category',
    'blog.card.url': 'URL',
    'blog.card.status': 'Status',
    'blog.card.date': 'Date',
    'blog.card.published_at': 'Published at',
    'blog.card.expected_date': 'Expected date',
    'blog.card.fact_check_title': 'Fact check',
    'blog.card.fact_check_method': 'Method',
    'blog.card.fact_check_claims': 'Claims total',
    'blog.card.fact_check_exact': 'Exact verbatim',
    'blog.card.fact_check_fixed': 'Fixed',
    'blog.card.fact_check_open': 'Open issues',
    'blog.card.fact_check_checked_at': 'Checked at',
    'blog.card.fact_check_not_measured': 'not measured',
    'blog.card.fact_check_warning': 'quotes not verified verbatim',
    'blog.card.alan_title': 'Alan',
    'blog.card.alan_sent_at': 'Emailed at',
    'blog.card.alan_not_sent': 'not sent',
    'blog.card.alan_no_record': 'No record in publication log',
    'blog.card.quality_title': 'Quality',
    'blog.card.quality_not_measured': 'not measured',
    'blog.card.quality_passed': 'checks passed ({n}/{total})',
    'blog.card.quality_failed': '{n} failed',
    'blog.card.btn_close': 'Close',

    'blog.link.en': 'Read',
    'blog.link.view': 'View',

    'blog.pending.banner': 'Queue has {n} articles — scheduled through {date}',
    'blog.pending.banner_empty': 'No pending articles in queue',
    'blog.pending.col_pos': '#',
    'blog.pending.col_expected': 'Expected',
    'blog.pending.col_title': 'Title',
    'blog.pending.col_category': 'Category',
    'blog.pending.col_queue_id': 'Queue ID',
    'blog.pending.expected_label': 'expected {date}',
    'blog.pending.empty': 'The publishing queue is currently empty',

    'blog.assistant.katifi': 'Katifi',

    'blog.suggestions.btn_propose': 'Propose Topic',
    'blog.suggestions.writer_notice': 'Before writing: verify statutes, amounts and deadlines against official sources.',
    'blog.suggestions.cycle_summary': 'Katifi cycle {cycle}: {rewrites} rewrite · {news} new',
    'blog.suggestions.filter_all': 'All statuses',
    'blog.suggestions.filter_proposed': 'Proposed',
    'blog.suggestions.filter_accepted': 'Accepted',
    'blog.suggestions.filter_in_queue': 'In queue',
    'blog.suggestions.filter_published': 'Published',
    'blog.suggestions.filter_rejected': 'Rejected',
    'blog.suggestions.filter_kind_label': 'Kind',
    'blog.suggestions.filter_kind_all': 'All kinds',
    'blog.suggestions.filter_kind_new': 'New',
    'blog.suggestions.filter_kind_rewrite': 'Rewrite',
    'blog.suggestions.kind_new': 'New',
    'blog.suggestions.kind_rewrite': 'Rewrite',
    'blog.suggestions.target_article': 'Rewrites',
    'blog.suggestions.proposed_by_katifi': 'Proposed by {name}',
    'blog.suggestions.proposed_by_staff': 'Proposed by staff',
    'blog.suggestions.proposed_by_owner': 'Proposed by owner',
    'blog.suggestions.generated_with': 'Generated with: {engine}',
    'blog.suggestions.col_title': 'Topic',
    'blog.suggestions.col_keyword': 'Target Keyword',
    'blog.suggestions.col_priority': 'Priority',
    'blog.suggestions.col_language': 'Language',
    'blog.suggestions.col_status': 'Status',
    'blog.suggestions.col_queue_id': 'Queue ID',
    'blog.suggestions.col_actions': 'Actions',
    'blog.suggestions.empty': 'No topic suggestions found',
    'blog.suggestions.counter_proposed': 'Proposed {count}',
    'blog.suggestions.counter_accepted': 'Accepted {count}',
    'blog.suggestions.counter_in_queue': 'In queue {count}',
    'blog.suggestions.counter_published': 'Published {count}',
    'blog.suggestions.view_in_queue': 'View in In Queue tab',
    'blog.suggestions.view_in_published': 'View in Published tab',

    'blog.status.proposed': 'Proposed',
    'blog.status.accepted': 'Accepted — waiting to be written',
    'blog.status.accepted_tooltip': 'Article will appear in In Queue after it is written and quotes are verified',
    'blog.status.in_queue': 'In queue',
    'blog.status.published': 'Published',
    'blog.status.rejected': 'Rejected',
    'blog.status.topic': 'Topic',
    'blog.status.drafting': 'Drafting',
    'blog.status.verifying': 'Verifying',
    'blog.status.ready': 'Ready',
    'blog.status.queued': 'Queued',
    'blog.status.failed': 'Failed',

    'blog.priority.high': 'High',
    'blog.priority.normal': 'Normal',
    'blog.priority.low': 'Low',

    'blog.language.both': 'EN + RU',
    'blog.language.en': 'EN only',
    'blog.language.ru': 'RU only',

    'blog.modal.title': 'Suggest a Blog Topic',
    'blog.modal.field_title': 'Title or Topic (required)',
    'blog.modal.field_keyword': 'Target Keyword (optional)',
    'blog.modal.field_language': 'Target Language',
    'blog.modal.field_priority': 'Priority',
    'blog.modal.field_notes': 'Notes or Details',
    'blog.modal.field_queue_id': 'Linked Queue ID (optional)',
    'blog.modal.btn_cancel': 'Cancel',
    'blog.modal.btn_submit': 'Save Topic',
    'blog.modal.submitting': 'Saving...',
    'blog.modal.error': 'Failed to save topic suggestion',

    'blog.action.accept': 'Accept',
    'blog.action.reject': 'Reject',
    'blog.action.edit': 'Edit',
    'blog.action.save': 'Save',
    'blog.action.cancel': 'Cancel',
};

const RU = {
    'blog.header.title': 'Конвейер блога',
    'blog.header.subtitle': 'Вышедшие статьи, состояние очереди и рекомендованные темы estatelawnewyork.com',
    'blog.status.pipeline_date': 'Данные конвейера на {date}',
    'blog.banner.stale': 'Данные конвейера устарели с {time}',
    'blog.banner.no_data': 'Конвейер ещё не присылал данные',

    'blog.tabs.published': 'Вышло',
    'blog.tabs.pending': 'В очереди',
    'blog.tabs.suggestions': 'Темы',

    'blog.published.filter_7d': '7 дней',
    'blog.published.filter_30d': '30 дней',
    'blog.published.filter_all': 'Все дни',
    'blog.published.count_7d': 'за 7 дней: {n}',
    'blog.published.count_total': 'всего статей: {n}',
    'blog.published.col_date': 'Дата',
    'blog.published.col_title': 'Заголовок',
    'blog.published.col_category': 'Категория',
    'blog.published.col_links': 'Ссылка',
    'blog.published.col_status': 'Статус',
    'blog.published.col_quality': 'Качество',
    'blog.published.col_verify': 'Качество',
    'blog.published.empty': 'Нет вышедших статей за выбранный период',

    'blog.quality.not_measured': 'не измерено',
    'blog.quality.partial': '{passed}/{total}, {not_measured} не измерено',
    'blog.quality.checks_passed': 'проверок пройдено ({n}/{total})',
    'blog.quality.checks_failed': 'сбоев: {n}',
    'blog.quality.failed_list': 'Сбои: {list}',
    'blog.quality.check.answer_first': 'Прямой ответ в первом абзаце',
    'blog.quality.check.question_headings': 'Подзаголовки-вопросы',
    'blog.quality.check.faq_schema': 'Разметка FAQ (3-8 вопросов, 30-120 слов)',
    'blog.quality.check.article_schema': 'Разметка Article (заголовок, даты, автор, издатель)',
    'blog.quality.check.reviewed_by': 'Рецензия Alan Vaitzman, Esq.',
    'blog.quality.check.statute_cited': 'Цитаты законов (§) и ссылки на первоисточники',
    'blog.quality.check.fact_check_verbatim': 'Дословная сверка цитат в браузере',
    'blog.quality.check.internal_links': 'Ссылки на статьи блога и страницы практики',
    'blog.quality.check.meta': 'Заголовок, описание и канонический адрес',
    'blog.quality.check.indexable': 'HTTP 200, в карте сайта, без noindex',
    'blog.quality.check.canon_words': 'Соблюдение канона ELN (без запрещённых слов)',

    'blog.verify.ok': 'проверено',
    'blog.verify.fail': 'сбой проверки',
    'blog.verify.unverified': 'не измерено',

    'blog.card.title': 'Карточка статьи',
    'blog.card.btn_details': 'Детали',
    'blog.card.slug': 'Slug',
    'blog.card.category': 'Категория',
    'blog.card.url': 'Адрес',
    'blog.card.status': 'Статус',
    'blog.card.date': 'Дата',
    'blog.card.published_at': 'Опубликовано',
    'blog.card.expected_date': 'Ожидаемая дата',
    'blog.card.fact_check_title': 'Сверка фактов',
    'blog.card.fact_check_method': 'Метод',
    'blog.card.fact_check_claims': 'Всего утверждений',
    'blog.card.fact_check_exact': 'Дословных цитат',
    'blog.card.fact_check_fixed': 'Исправлено',
    'blog.card.fact_check_open': 'Открытых замечаний',
    'blog.card.fact_check_checked_at': 'Дата сверки',
    'blog.card.fact_check_not_measured': 'не измерено',
    'blog.card.fact_check_warning': 'quotes not verified verbatim',
    'blog.card.alan_title': 'Письмо Алану',
    'blog.card.alan_sent_at': 'Отправлено',
    'blog.card.alan_not_sent': 'не отправлено',
    'blog.card.alan_no_record': 'Нет записи в журнале публикаций',
    'blog.card.quality_title': 'Качество',
    'blog.card.quality_not_measured': 'не измерено',
    'blog.card.quality_passed': 'проверок пройдено ({n}/{total})',
    'blog.card.quality_failed': 'сбоев: {n}',
    'blog.card.btn_close': 'Закрыть',

    'blog.link.en': 'Читать',
    'blog.link.view': 'Открыть',

    'blog.pending.banner': 'В очереди {n} статей — хватит до {date}',
    'blog.pending.banner_empty': 'В очереди нет статей',
    'blog.pending.col_pos': '№',
    'blog.pending.col_expected': 'Ожидается',
    'blog.pending.col_title': 'Заголовок',
    'blog.pending.col_category': 'Категория',
    'blog.pending.col_queue_id': 'ID очереди',
    'blog.pending.expected_label': 'ожидается {date}',
    'blog.pending.empty': 'Очередь публикаций пуста',

    'blog.assistant.katifi': 'Katifi',

    'blog.suggestions.btn_propose': 'Предложить тему',
    'blog.suggestions.writer_notice': 'Перед написанием: статьи закона, суммы и сроки сверять по официальным источникам.',
    'blog.suggestions.cycle_summary': 'Цикл Katifi {cycle}: {rewrites} rewrite · {news} new',
    'blog.suggestions.filter_all': 'Все статусы',
    'blog.suggestions.filter_proposed': 'Предложены',
    'blog.suggestions.filter_accepted': 'Приняты',
    'blog.suggestions.filter_in_queue': 'В очереди',
    'blog.suggestions.filter_published': 'Вышли',
    'blog.suggestions.filter_rejected': 'Отклонены',
    'blog.suggestions.filter_kind_label': 'Вид',
    'blog.suggestions.filter_kind_all': 'Все виды',
    'blog.suggestions.filter_kind_new': 'Новая',
    'blog.suggestions.filter_kind_rewrite': 'Переписать',
    'blog.suggestions.kind_new': 'Новая',
    'blog.suggestions.kind_rewrite': 'Переписать',
    'blog.suggestions.target_article': 'Статья для переписывания',
    'blog.suggestions.proposed_by_katifi': 'Предложила {name}',
    'blog.suggestions.proposed_by_staff': 'Предложил сотрудник',
    'blog.suggestions.proposed_by_owner': 'Предложил владелец',
    'blog.suggestions.generated_with': 'Сгенерировано с помощью: {engine}',
    'blog.suggestions.col_title': 'Тема',
    'blog.suggestions.col_keyword': 'Ключевое слово',
    'blog.suggestions.col_priority': 'Приоритет',
    'blog.suggestions.col_language': 'Язык',
    'blog.suggestions.col_status': 'Статус',
    'blog.suggestions.col_queue_id': 'ID очереди',
    'blog.suggestions.col_actions': 'Действия',
    'blog.suggestions.empty': 'Нет предложенных тем',
    'blog.suggestions.counter_proposed': 'Предложены {count}',
    'blog.suggestions.counter_accepted': 'Приняты {count}',
    'blog.suggestions.counter_in_queue': 'В очереди {count}',
    'blog.suggestions.counter_published': 'Опубликованы {count}',
    'blog.suggestions.view_in_queue': 'Посмотреть во вкладке «В очереди»',
    'blog.suggestions.view_in_published': 'Посмотреть во вкладке «Опубликованные»',

    'blog.status.proposed': 'Предложена',
    'blog.status.accepted': 'Принята — ждёт написания',
    'blog.status.accepted_tooltip': 'Статья появится во вкладке «В очереди» после написания и сверки цитат',
    'blog.status.in_queue': 'В очереди',
    'blog.status.published': 'Вышла',
    'blog.status.rejected': 'Отклонена',
    'blog.status.topic': 'Тема',
    'blog.status.drafting': 'Черновик',
    'blog.status.verifying': 'Сверка',
    'blog.status.ready': 'Готово',
    'blog.status.queued': 'В очереди',
    'blog.status.failed': 'Сбой',

    'blog.priority.high': 'Высокий',
    'blog.priority.normal': 'Обычный',
    'blog.priority.low': 'Низкий',

    'blog.language.both': 'EN + RU',
    'blog.language.en': 'Только EN',
    'blog.language.ru': 'Только RU',

    'blog.modal.title': 'Предложить тему для блога',
    'blog.modal.field_title': 'Заголовок или тема (обязательно)',
    'blog.modal.field_keyword': 'Ключевое слово (необязательно)',
    'blog.modal.field_language': 'Язык статьи',
    'blog.modal.field_priority': 'Приоритет',
    'blog.modal.field_notes': 'Заметки или детали',
    'blog.modal.field_queue_id': 'Связь с элементом очереди (необязательно)',
    'blog.modal.btn_cancel': 'Отмена',
    'blog.modal.btn_submit': 'Сохранить тему',
    'blog.modal.submitting': 'Сохранение...',
    'blog.modal.error': 'Ошибка сохранения темы',

    'blog.action.accept': 'Принять',
    'blog.action.reject': 'Отклонить',
    'blog.action.edit': 'Редактировать',
    'blog.action.save': 'Сохранить',
    'blog.action.cancel': 'Отмена',
};

export const SLOVAR = Object.freeze({ en: Object.freeze(EN), ru: Object.freeze(RU) });

export function perevesti(lang, key, vars) {
    const slovar = SLOVAR[lang];
    if (!slovar || !Object.prototype.hasOwnProperty.call(slovar, key)) return `[${key}]`;
    const shablon = slovar[key];
    if (!vars || typeof vars !== 'object') return shablon;
    return shablon.replace(/\{([a-zA-Z_]+)\}/g, (celoe, imya) => (
        Object.prototype.hasOwnProperty.call(vars, imya) && vars[imya] !== undefined && vars[imya] !== null
            ? String(vars[imya])
            : celoe
    ));
}

export const raznitsaKlyuchey = (a, b) => Object.keys(a).filter((k) => !Object.prototype.hasOwnProperty.call(b, k)).sort();

